import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class Bank extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    /**
     * Save item to API
     */
    save(params = {}, query = {}) {
        if (query) {
            this.constructor.deprecate('query on save()', 'Add it to params.');
        }
        const data = this.toAPI();
        const newParams = {
            ...this.__params,
            ...params,
            id: this.pk
        };

        delete newParams.metadata;

        let promise = null;
        const url = this.constructor.getItemUrl(newParams);
        promise = this.constructor.fetcher.post(url, { query, ...params, data });

        return promise.then(result => {
            const { response } = result;
            this._updateInPlace(response instanceof Object ? { ...response } : response);
            this.constructor.fetcher.clear_cache(this.constructor.listUrl(newParams));
            if (this.pk) {
                this.constructor.fetcher.clear_cache(this.constructor.getItemUrl({ ...newParams, id: this.pk }));
            }
            return result;
        });
    }

    static listUrl() {
        return `/ticket/accounting/organizations`;
    }
}
